module.exports = __webpack_public_path__ + "static/media/LGmsp.fa993208.jpg";